<template>
  <div v-if="shouldShow" class="notification-permission-banner">
    <div class="banner-content">
      <div class="banner-icon">🔔</div>
      <div class="banner-text">
        <h3>通知を有効にする</h3>
        <p>新しいメッセージをリアルタイムで受信します</p>
      </div>
      <div class="banner-actions">
        <button @click="requestPermission" class="btn-enable">
          有効にする
        </button>
        <button @click="dismiss" class="btn-later">
          後で
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import {ref, onMounted} from 'vue';
import {ChatsStore} from '../store/chats';

const chatsStore = ChatsStore();
const shouldShow = ref(false);

onMounted(() => {
  checkPermissionStatus();
});

function checkPermissionStatus() {
  if (!('Notification' in window)) {
    return;
  }

  const permission = Notification.permission;
  const dismissed = localStorage.getItem('notification_permission_dismissed');

  // Show banner if permission is default and user hasn't dismissed
  if (permission === 'default' && !dismissed) {
    shouldShow.value = true;
  }
}

async function requestPermission() {
  try {
    const token = await chatsStore.requestNotificationPermission();
    if (token) {
      console.log('✓ Notification permission granted');
      shouldShow.value = false;
    }
  } catch (error) {
    console.error('Error requesting permission:', error);
  }
}

function dismiss() {
  shouldShow.value = false;
  localStorage.setItem('notification_permission_dismissed', Date.now());
}
</script>

<style scoped>
.notification-permission-banner {
  position: fixed;
  bottom: 20px;
  right: 20px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  max-width: 400px;
  z-index: 9999;
  animation: slideIn 0.3s ease-out;
}

@keyframes slideIn {
  from {
    transform: translateY(100px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.banner-content {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 20px;
}

.banner-icon {
  font-size: 32px;
  flex-shrink: 0;
}

.banner-text h3 {
  margin: 0 0 4px 0;
  font-size: 16px;
  font-weight: 600;
  color: #1a1a1a;
}

.banner-text p {
  margin: 0;
  font-size: 14px;
  color: #666;
}

.banner-actions {
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex-shrink: 0;
}

.btn-enable {
  background: #4F46E5;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 8px;
  font-weight: 500;
  cursor: pointer;
  white-space: nowrap;
}

.btn-enable:hover {
  background: #4338CA;
}

.btn-later {
  background: transparent;
  color: #666;
  border: none;
  padding: 8px 20px;
  border-radius: 8px;
  font-size: 14px;
  cursor: pointer;
}

.btn-later:hover {
  background: #f3f4f6;
}

@media (max-width: 640px) {
  .notification-permission-banner {
    bottom: 10px;
    right: 10px;
    left: 10px;
    max-width: none;
  }

  .banner-content {
    flex-direction: column;
    text-align: center;
  }

  .banner-actions {
    width: 100%;
  }

  .btn-enable,
  .btn-later {
    width: 100%;
  }
}
</style>